import { createAction } from '@reduxjs/toolkit'

export const resetChangesTable = createAction('RESET_CHANGES_TABLE')
